export default "__VITE_ASSET__25h_jVQD__"